// Consumer first so Fortress leads the product menus; Enterprise keeps its
// own group and order.
export const PRODUCT_CATEGORIES = Object.freeze({
  consumer: "Consumer",
  enterprise: "Enterprise",
});

export const products = [
  { slug: "halo-fortress", label: "Fortress", summary: "The Mac app with Halo SuperVPN and SecureShield together. Private connectivity and clearer Mac security.", category: "consumer", featured: true },
  { slug: "halo-fortress-pro", label: "Fortress Pro", summary: "Fortress plus Network Guard. Privacy, Mac security and control over the apps that connect.", category: "consumer" },
  { slug: "halo", label: "Halo SuperVPN", summary: "Private connectivity with a clear protection state for Windows, Apple devices and Android.", category: "consumer" },
  { slug: "secureshield", label: "SecureShield", summary: "See what's actually protecting your Mac — and exactly how to fix it.", category: "consumer" },
  { slug: "secureshield-pro", label: "SecureShield Pro", summary: "SecureShield plus Network Guard — a quiet watch over every connection.", category: "consumer" },
  { slug: "secureai", label: "SecureAI", summary: "Protect the path your AI tools take — without reading prompts, code or tokens.", category: "consumer" },
  { slug: "platform", label: "LightningFlow Platform", summary: "Secure traffic, operational state and distributed control in one system.", category: "enterprise" },
  { slug: "secureai-enterprise", label: "SecureAI", summary: "Enterprise licensing for the path your team's AI tools take.", category: "enterprise" },
  { slug: "quantumcloak", label: "QuantumCloak", summary: "Reduce exposure and protect access across your network.", category: "enterprise" },
  { slug: "quantumcubedb", label: "QuantumCubeDB", summary: "Turn live network data into clear operational intelligence.", category: "enterprise" },
  { slug: "fpga-acceleration", label: "FPGA Acceleration", summary: "Accelerate supported network workloads without losing control.", category: "enterprise" },
  { slug: "sheila-ai", label: "Sheila AI", summary: "Your AI operator and developer. Connected operational memory, coordinated work and human control.", category: "enterprise" },
];

export function productsByCategory() {
  return Object.keys(PRODUCT_CATEGORIES).map((category) => ({
    category,
    label: PRODUCT_CATEGORIES[category],
    items: products.filter((product) => product.category === category),
  }));
}
